import { render, staticRenderFns } from "./PresentTable.vue?vue&type=template&id=67ca4f1c&scoped=true"
import script from "./PresentTable.vue?vue&type=script&lang=js"
export * from "./PresentTable.vue?vue&type=script&lang=js"
import style0 from "./PresentTable.vue?vue&type=style&index=0&id=67ca4f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ca4f1c",
  null
  
)

export default component.exports